import { getCampaignUser } from "../../../helpers/campaignUserManager";
import { get } from "svelte/store";
import { updateSession, sessionStore } from "../../../stores/session";
import { navigateToPath } from "../../../routing";
import PATHS from "../../../constants/routePaths";
import { defaultHandler } from "./handlers";
import { startPoller } from "../../poller";
import { getCurrentProcess } from "../../../utils";

export const startPolling = (handler = defaultHandler): { stopPolling: boolean } => {
  const pollingFunction = () => StatusChecker.checkWorkflowStatus(handler);
  const timeOutHandler = () => navigateToPath(PATHS.ERROR);

  return startPoller(
    new Date(),
    { pollingFunction, timeOutHandler }
  );
};

export const StatusChecker = {
  checkWorkflowStatus: async (handler = defaultHandler) => {
    const campaignUser = await getCampaignUser({ refresh: true });
    const { current_status_updated_at: currentStatusUpdatedAt } = campaignUser;
    const session = get(sessionStore);

    if (currentStatusUpdatedAt !== session.lastUserStatusUpdate) {
      updateSession({
        internalProcessKey: getCurrentProcess(campaignUser.metadata),
        foojiData: {
          ...session.foojiData,
          campaign_user: campaignUser
        }
      });
      
      return handler(campaignUser);
    }

    return false;
  }
};
